import api from "@/api/api";

export default {
  show() {
    return api.get("main/user-profile");
  },
  updateNotificationPreferences(payload) {
    return api.patch("main/user-profile/notification-preferences", payload);
  },
};
